import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize32 {
  size: '32';
}
type OverrideIconSize = OverrideIconSize32;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '32') {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM16.8036 14.3298L16.7689 13.7242C16.6649 12.1548 17.5782 10.7212 19.0233 10.1651C19.5551 9.9674 20.4568 9.94269 21.0464 10.1157C21.2777 10.1898 21.717 10.437 22.0291 10.6594L22.5956 11.0673L23.2199 10.8572C23.5667 10.746 24.0291 10.5606 24.2372 10.437C24.4338 10.3258 24.6072 10.264 24.6072 10.3011C24.6072 10.5112 24.1794 11.2279 23.8211 11.6234C23.3355 12.1795 23.4742 12.2289 24.4569 11.8582C25.0465 11.6481 25.0581 11.6481 24.9425 11.8829C24.8731 12.0065 24.5147 12.439 24.1332 12.8344C23.4858 13.5141 23.4511 13.5883 23.4511 14.1567C23.4511 15.0342 23.058 16.8631 22.665 17.8641C21.9366 19.7425 20.3759 21.6827 18.8152 22.659C16.6186 24.0307 13.6937 24.3768 11.2313 23.5735C10.4104 23.3016 9 22.6096 9 22.486C9 22.4489 9.42775 22.3995 9.94799 22.3871C11.0347 22.3624 12.1214 22.0411 13.0463 21.4727L13.6706 21.0772L12.9538 20.8177C11.9365 20.4469 11.0232 19.5942 10.7919 18.791C10.7226 18.5315 10.7457 18.5191 11.3931 18.5191L12.0636 18.5067L11.4972 18.2225C10.8266 17.8641 10.2139 17.2586 9.91331 16.6407C9.69365 16.1958 9.41619 15.0712 9.49712 14.9847C9.52024 14.9477 9.76302 15.0218 10.0405 15.1207C10.8382 15.4296 10.9422 15.3555 10.4798 14.8364C9.61273 13.8972 9.34683 12.5008 9.76302 11.1785L9.95955 10.5853L10.7226 11.3886C12.2833 13.0075 14.1215 13.9714 16.2256 14.2556L16.8036 14.3298Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 32 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'twitter');
export default IconComponent;
